import React, { memo } from 'react';
import { getPlatformStyles } from '@direct-frontend/platform-code';

import { Text } from '../Text/Text';
import { cn } from '../../lib/css/className/className';

getPlatformStyles({
    common: import('./InfoBase.css'),
});

const cls = cn('InfoBaseBottomText');

export interface InfoBaseBottomTextProps {
    /**
     * Текст для отображения внизу блока
     */
    children?: string;

    /**
     * CSS класс для стилизации
     */
    className?: string;
}

/**
 * Компонент для отображения дополнительного текста внизу информационного блока.
 */
export const InfoBaseBottomText = memo<InfoBaseBottomTextProps>(function InfoBaseBottomText({ children, className }) {
    if (!children) {
        return null;
    }

    return (
        <Text textAlign="right" size="s" color="current" role="supplementary" className={cls(null, [className])}>
            {children}
        </Text>
    );
});
